<section id="home">
  <div class="row hero">
    <div class="familia text-center"></div>
    <a routerLink="/animacoes"><button class="btn btn-outline-secondary btn-lg" >Assista a animação</button></a>
  </div>
</section>

<div class="container">
  <div class="row">
    <div class="col projeto">
      <h2><b>Projeto</b> de feira de ciências</h2>
      <p>O projeto dessa feira está sendo apoiado pelo Conselho Nacional de Desenvolvimento Científico e
        Tecnológico (CNPq) e tem âmbito nacional, envolvendo participações em 15 unidades da federação, 14
        estados e o Distrito Federal. Nessas unidades reuniremos grupos de docentes das áreas de ciências e
        biologia do ensino fundamental e médio com os quais desenvolveremos as atividades da feira.</p>
    </div>
  </div>
  <div class="row featured">
    <div class="col-md-4 post_item">
      <div class="post_item_img" routerLink="/entrevista">
        <img src="assets/images/home/feat-1.png" alt="">
        <a class="link" routerLink="/entrevista"></a>
      </div>
      <div class="post_item_content">
        <a class="title" routerLink="/entrevista">Entrevista sobre o projeto</a>
        <p>Vídeo do projeto "O Tempo na Vida". Entrevista com o Prof. Luiz Menna-Barreto, da Escola de Artes, Ciências e Humanidades da Universidade de São Paulo - USP</p>
      </div>
    </div>
    <div class="col-md-4 post_item">
      <div class="post_item_img" routerLink="/materiais">
        <img src="assets/images/home/feat-2.jpg" routerLink="/materiais" alt="">
        <a routerLink="/materiais"></a>
      </div>
      <div class="post_item_content">
        <a class="title" routerLink="/materiais">Material de apoio</a>
        <p>Faça o download do material de apoio do projeto e seus mapas conceituais para o ensino infantil, fundamental e médio.</p>
      </div>
    </div>
    <div class="col-md-4 post_item">
      <div class="post_item_img" routerLink="/contatos">
        <img src="assets/images/home/feat-3.jpg" alt="">
        <a class="link" href="blog-post.html"></a>
      </div>
      <div class="post_item_content">
        <a class="title" routerLink="/contatos">Solicite mídia com a animação</a>
        <p>Você pode solicitar uma cópia da animação para uso em sala de aula onde não haja conexão com a Internet.</p>
      </div>
    </div>
  </div>
</div>
